import { render } from "./indexGeneral.vue?vue&type=template&id=977e9fd2"
import script from "./indexGeneral.vue?vue&type=script&lang=js"
export * from "./indexGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__